import { useDeviceType } from '@cian/ui-kit';

import { useIsOfferCardPage } from './useIsOfferCardPage';
import { useApplicationContext } from '../utils/applicationContext';

export const useMobileBottomNavigation = () => {
  const { config } = useApplicationContext();

  const isMobileBottomNavigationEnabled = config.get<boolean>('mobileBottomNavigation.Enabled') ?? false;

  const deviceType = useDeviceType();
  const isOfferCard = useIsOfferCardPage();

  return isMobileBottomNavigationEnabled && deviceType !== 'desktop' && !isOfferCard;
};
